import React from "react";
import AdminCatalogInstitutionsRoutes from "./AdminCatalogInstitutionsRoutes";

import { useTracking } from "react-tracking";
import { useDispatch, useSelector } from "react-redux";
import { startRegisterTrackingHistory } from "../../app/actions/trackingHistoryActions";

const AdminCatalogInstitutionsScreen = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const { Track } = useTracking(
    {
      module: "Administration Institution",
      page: "Admin Institution Screen",
      user_id: user.user_id,
      user_name: user.user_name,
      
    },
    {
      dispatch: (data) => {

        dispatch(startRegisterTrackingHistory(data));
        
      },
    }
  );

  return (
    <div>
      <Track>
        <AdminCatalogInstitutionsRoutes />
      </Track>
    </div>
  );
};

export default AdminCatalogInstitutionsScreen;
